import { ReactComponent as ReportesIcon } from '../../assets/icons/reporte.svg';
import { CardInfo } from './cardData';

export const reportesCardData: CardInfo[] = [
  {
    id: 'expedientes-produccion',
    icon: ReportesIcon,
    title: 'Reportes - Expedientes de Producción',
    path: '/reportes/expedientes-produccion',
  },
];
